import React from 'react';
import { IconProps } from '../types';

export const TelegramIcon = (props: IconProps) => {
  const { size = 28, color = '#FFFFFF', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 28 28'
    >
      <path
        fill={color}
        d='M19.6 8.822l-2.104 10.983s-.294.761-1.103.396l-4.854-3.854-.022-.012c.655-.61 5.74-5.343 5.962-5.558.344-.332.13-.53-.27-.279l-7.51 4.94-2.897-1.01s-.456-.168-.5-.534c-.044-.365.515-.563.515-.563L18.63 8.532s.97-.441.97.29z'
      />
    </svg>
  );
};
